import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: '#',
      redirect: '/home',
      component: () => import(/* webpackChunkName: "page" */ '@/pages/layout/index.vue'),
      children: [
        {
          path: '/home',
          name: 'home',
          component: () => import(/* webpackChunkName: "page" */ '@/pages/home/index.vue')
        },
        {
          path: '/product',
          name: 'product',
          redirect: '/product/DCS',
          component: () => import(/* webpackChunkName: "page" */ '@/pages/product/index.vue'),
          children: [
            {
              path: '/product/DCS',
              name: 'DCS',
              component: () => import(/* webpackChunkName: "page" */ '@/pages/product/DCS.vue')
            },
            {
              path: '/product/YMT',
              name: 'YMT',
              component: () => import(/* webpackChunkName: "page" */ '@/pages/product/YMT.vue')
            },
            {
              path: '/product/valve',
              name: 'valve',
              component: () => import(/* webpackChunkName: "page" */ '@/pages/product/valve.vue')
            },
            {
              path: '/product/gateway',
              name: 'gateway',
              component: () => import(/* webpackChunkName: "page" */ '@/pages/product/gateway.vue')
            },
            {
              path: '/product/electrical',
              name: 'electrical',
              component: () => import(/* webpackChunkName: "page" */ '@/pages/product/electrical.vue')
            }
          ]
        },
        {
          path: '/solution',
          name: 'solution',
          component: () => import(/* webpackChunkName: "page" */ '@/pages/solution/index.vue'),
        },
        {
          path: '/solution/info',
          name: 'solutionInfo',
          component: () => import(/* webpackChunkName: "page" */ '@/pages/solution/info.vue')
        },
        {
          path: '/major',
          name: 'major',
          component: () => import(/* webpackChunkName: "page" */ '@/pages/major/index.vue')
        },
        {
          path: '/service',
          name: 'service',
          component: () => import(/* webpackChunkName: "page" */ '@/pages/service/index.vue')
        },
        {
          path: '/news',
          name: 'news',
          component: () => import(/* webpackChunkName: "page" */ '@/pages/news/index.vue')
        },

        {
          path: '/industry',
          name: 'industry',
          component: () => import(/* webpackChunkName: "page" */ '@/pages/industry/index.vue')
        },
        {
          path: '/yun',
          name: 'yun',
          component: () => import(/* webpackChunkName: "page" */ '@/pages/yun/index.vue')
        },
        {
          path: '/about',
          name: 'about',
          redirect:'/about/company',
          component: () => import(/* webpackChunkName: "page" */ '@/pages/about/index.vue'),
          children: [
            {
              path: '/about/company',
              name: 'network',
              component: () => import(/* webpackChunkName: "page" */ '@/pages/about/company.vue')
            },
            {
              path: '/about/network',
              name: 'network',
              component: () => import(/* webpackChunkName: "page" */ '@/pages/about/network.vue')
            },
            {
              path: '/about/joinus',
              name: 'joinus',
              component: () => import(/* webpackChunkName: "page" */ '@/pages/about/joinus.vue')
            },
            {
              path: '/about/recruit',
              name: 'recruit',
              component: () => import(/* webpackChunkName: "page" */ '@/pages/about/recruit.vue')
            },
          ]
        },
        {
          path: '/content',
          name: 'content',
          component: () => import(/* webpackChunkName: "page" */ '@/pages/content/index.vue')
        },
      ]
    }
  ],
  mode: 'hash'
})



// WEBPACK FOOTER //
// ./src/router/index.js